/**
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '../BaseModel';

export class Projektdaten extends BaseModel {
    data: { [key: string]: string | number } = {}
}
